module.exports = __webpack_public_path__ + "files/cb86c375a267c9ad600d23e8c106aa28.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/roboto-bolditalic-webfont.woff2
// module id = 912
// module chunks = 60